/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AppRouteImport } from './routes/app'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppIndexRouteImport } from './routes/app.index'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as AppTemplatesRouteImport } from './routes/app.templates'
import { Route as AppExportsRouteImport } from './routes/app.exports'
import { Route as AppDatasetsRouteImport } from './routes/app.datasets'
import { Route as AdminUsersRouteImport } from './routes/admin.users'
import { Route as AdminOrgsRouteImport } from './routes/admin.orgs'
import { Route as AdminAuditRouteImport } from './routes/admin.audit'
import { Route as AcceptInviteTokenRouteImport } from './routes/accept-invite.$token'
import { Route as AppTemplatesIndexRouteImport } from './routes/app.templates.index'
import { Route as AppDatasetsIndexRouteImport } from './routes/app.datasets.index'
import { Route as AppTemplatesIdRouteImport } from './routes/app.templates.$id'
import { Route as AppSettingsMembersRouteImport } from './routes/app.settings.members'
import { Route as AppSettingsGoogleRouteImport } from './routes/app.settings.google'
import { Route as AppSettingsApiKeysRouteImport } from './routes/app.settings.api-keys'
import { Route as AppMappingsMappingIdRouteImport } from './routes/app.mappings.$mappingId'
import { Route as AppDatasetsIdRouteImport } from './routes/app.datasets.$id'
import { Route as AppTemplatesIdIndexRouteImport } from './routes/app.templates.$id.index'
import { Route as AppTemplatesIdMappingsRouteImport } from './routes/app.templates.$id.mappings'

const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/app',
  path: '/app',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any)
const AppTemplatesRoute = AppTemplatesRouteImport.update({
  id: '/templates',
  path: '/templates',
  getParentRoute: () => AppRoute,
} as any)
const AppExportsRoute = AppExportsRouteImport.update({
  id: '/exports',
  path: '/exports',
  getParentRoute: () => AppRoute,
} as any)
const AppDatasetsRoute = AppDatasetsRouteImport.update({
  id: '/datasets',
  path: '/datasets',
  getParentRoute: () => AppRoute,
} as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AdminRoute,
} as any)
const AdminOrgsRoute = AdminOrgsRouteImport.update({
  id: '/orgs',
  path: '/orgs',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAuditRoute = AdminAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AdminRoute,
} as any)
const AcceptInviteTokenRoute = AcceptInviteTokenRouteImport.update({
  id: '/accept-invite/$token',
  path: '/accept-invite/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AppTemplatesIndexRoute = AppTemplatesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppTemplatesRoute,
} as any)
const AppDatasetsIndexRoute = AppDatasetsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppDatasetsRoute,
} as any)
const AppTemplatesIdRoute = AppTemplatesIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AppTemplatesRoute,
} as any)
const AppSettingsMembersRoute = AppSettingsMembersRouteImport.update({
  id: '/settings/members',
  path: '/settings/members',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsGoogleRoute = AppSettingsGoogleRouteImport.update({
  id: '/settings/google',
  path: '/settings/google',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsApiKeysRoute = AppSettingsApiKeysRouteImport.update({
  id: '/settings/api-keys',
  path: '/settings/api-keys',
  getParentRoute: () => AppRoute,
} as any)
const AppMappingsMappingIdRoute = AppMappingsMappingIdRouteImport.update({
  id: '/mappings/$mappingId',
  path: '/mappings/$mappingId',
  getParentRoute: () => AppRoute,
} as any)
const AppDatasetsIdRoute = AppDatasetsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AppDatasetsRoute,
} as any)
const AppTemplatesIdIndexRoute = AppTemplatesIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppTemplatesIdRoute,
} as any)
const AppTemplatesIdMappingsRoute = AppTemplatesIdMappingsRouteImport.update({
  id: '/mappings',
  path: '/mappings',
  getParentRoute: () => AppTemplatesIdRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/accept-invite/$token': typeof AcceptInviteTokenRoute
  '/admin/audit': typeof AdminAuditRoute
  '/admin/orgs': typeof AdminOrgsRoute
  '/admin/users': typeof AdminUsersRoute
  '/app/datasets': typeof AppDatasetsRouteWithChildren
  '/app/exports': typeof AppExportsRoute
  '/app/templates': typeof AppTemplatesRouteWithChildren
  '/admin/': typeof AdminIndexRoute
  '/app/': typeof AppIndexRoute
  '/app/datasets/$id': typeof AppDatasetsIdRoute
  '/app/mappings/$mappingId': typeof AppMappingsMappingIdRoute
  '/app/settings/api-keys': typeof AppSettingsApiKeysRoute
  '/app/settings/google': typeof AppSettingsGoogleRoute
  '/app/settings/members': typeof AppSettingsMembersRoute
  '/app/templates/$id': typeof AppTemplatesIdRouteWithChildren
  '/app/datasets/': typeof AppDatasetsIndexRoute
  '/app/templates/': typeof AppTemplatesIndexRoute
  '/app/templates/$id/mappings': typeof AppTemplatesIdMappingsRoute
  '/app/templates/$id/': typeof AppTemplatesIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/accept-invite/$token': typeof AcceptInviteTokenRoute
  '/admin/audit': typeof AdminAuditRoute
  '/admin/orgs': typeof AdminOrgsRoute
  '/admin/users': typeof AdminUsersRoute
  '/app/exports': typeof AppExportsRoute
  '/admin': typeof AdminIndexRoute
  '/app': typeof AppIndexRoute
  '/app/datasets/$id': typeof AppDatasetsIdRoute
  '/app/mappings/$mappingId': typeof AppMappingsMappingIdRoute
  '/app/settings/api-keys': typeof AppSettingsApiKeysRoute
  '/app/settings/google': typeof AppSettingsGoogleRoute
  '/app/settings/members': typeof AppSettingsMembersRoute
  '/app/datasets': typeof AppDatasetsIndexRoute
  '/app/templates': typeof AppTemplatesIndexRoute
  '/app/templates/$id/mappings': typeof AppTemplatesIdMappingsRoute
  '/app/templates/$id': typeof AppTemplatesIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/accept-invite/$token': typeof AcceptInviteTokenRoute
  '/admin/audit': typeof AdminAuditRoute
  '/admin/orgs': typeof AdminOrgsRoute
  '/admin/users': typeof AdminUsersRoute
  '/app/datasets': typeof AppDatasetsRouteWithChildren
  '/app/exports': typeof AppExportsRoute
  '/app/templates': typeof AppTemplatesRouteWithChildren
  '/admin/': typeof AdminIndexRoute
  '/app/': typeof AppIndexRoute
  '/app/datasets/$id': typeof AppDatasetsIdRoute
  '/app/mappings/$mappingId': typeof AppMappingsMappingIdRoute
  '/app/settings/api-keys': typeof AppSettingsApiKeysRoute
  '/app/settings/google': typeof AppSettingsGoogleRoute
  '/app/settings/members': typeof AppSettingsMembersRoute
  '/app/templates/$id': typeof AppTemplatesIdRouteWithChildren
  '/app/datasets/': typeof AppDatasetsIndexRoute
  '/app/templates/': typeof AppTemplatesIndexRoute
  '/app/templates/$id/mappings': typeof AppTemplatesIdMappingsRoute
  '/app/templates/$id/': typeof AppTemplatesIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/app'
    | '/login'
    | '/register'
    | '/accept-invite/$token'
    | '/admin/audit'
    | '/admin/orgs'
    | '/admin/users'
    | '/app/datasets'
    | '/app/exports'
    | '/app/templates'
    | '/admin/'
    | '/app/'
    | '/app/datasets/$id'
    | '/app/mappings/$mappingId'
    | '/app/settings/api-keys'
    | '/app/settings/google'
    | '/app/settings/members'
    | '/app/templates/$id'
    | '/app/datasets/'
    | '/app/templates/'
    | '/app/templates/$id/mappings'
    | '/app/templates/$id/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/register'
    | '/accept-invite/$token'
    | '/admin/audit'
    | '/admin/orgs'
    | '/admin/users'
    | '/app/exports'
    | '/admin'
    | '/app'
    | '/app/datasets/$id'
    | '/app/mappings/$mappingId'
    | '/app/settings/api-keys'
    | '/app/settings/google'
    | '/app/settings/members'
    | '/app/datasets'
    | '/app/templates'
    | '/app/templates/$id/mappings'
    | '/app/templates/$id'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/app'
    | '/login'
    | '/register'
    | '/accept-invite/$token'
    | '/admin/audit'
    | '/admin/orgs'
    | '/admin/users'
    | '/app/datasets'
    | '/app/exports'
    | '/app/templates'
    | '/admin/'
    | '/app/'
    | '/app/datasets/$id'
    | '/app/mappings/$mappingId'
    | '/app/settings/api-keys'
    | '/app/settings/google'
    | '/app/settings/members'
    | '/app/templates/$id'
    | '/app/datasets/'
    | '/app/templates/'
    | '/app/templates/$id/mappings'
    | '/app/templates/$id/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRouteWithChildren
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
  RegisterRoute: typeof RegisterRoute
  AcceptInviteTokenRoute: typeof AcceptInviteTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app': {
      id: '/app'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/': {
      id: '/app/'
      path: '/'
      fullPath: '/app/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/app/templates': {
      id: '/app/templates'
      path: '/templates'
      fullPath: '/app/templates'
      preLoaderRoute: typeof AppTemplatesRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/exports': {
      id: '/app/exports'
      path: '/exports'
      fullPath: '/app/exports'
      preLoaderRoute: typeof AppExportsRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/datasets': {
      id: '/app/datasets'
      path: '/datasets'
      fullPath: '/app/datasets'
      preLoaderRoute: typeof AppDatasetsRouteImport
      parentRoute: typeof AppRoute
    }
    '/admin/users': {
      id: '/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/orgs': {
      id: '/admin/orgs'
      path: '/orgs'
      fullPath: '/admin/orgs'
      preLoaderRoute: typeof AdminOrgsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/audit': {
      id: '/admin/audit'
      path: '/audit'
      fullPath: '/admin/audit'
      preLoaderRoute: typeof AdminAuditRouteImport
      parentRoute: typeof AdminRoute
    }
    '/accept-invite/$token': {
      id: '/accept-invite/$token'
      path: '/accept-invite/$token'
      fullPath: '/accept-invite/$token'
      preLoaderRoute: typeof AcceptInviteTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/templates/': {
      id: '/app/templates/'
      path: '/'
      fullPath: '/app/templates/'
      preLoaderRoute: typeof AppTemplatesIndexRouteImport
      parentRoute: typeof AppTemplatesRoute
    }
    '/app/datasets/': {
      id: '/app/datasets/'
      path: '/'
      fullPath: '/app/datasets/'
      preLoaderRoute: typeof AppDatasetsIndexRouteImport
      parentRoute: typeof AppDatasetsRoute
    }
    '/app/templates/$id': {
      id: '/app/templates/$id'
      path: '/$id'
      fullPath: '/app/templates/$id'
      preLoaderRoute: typeof AppTemplatesIdRouteImport
      parentRoute: typeof AppTemplatesRoute
    }
    '/app/settings/members': {
      id: '/app/settings/members'
      path: '/settings/members'
      fullPath: '/app/settings/members'
      preLoaderRoute: typeof AppSettingsMembersRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/settings/google': {
      id: '/app/settings/google'
      path: '/settings/google'
      fullPath: '/app/settings/google'
      preLoaderRoute: typeof AppSettingsGoogleRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/settings/api-keys': {
      id: '/app/settings/api-keys'
      path: '/settings/api-keys'
      fullPath: '/app/settings/api-keys'
      preLoaderRoute: typeof AppSettingsApiKeysRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/mappings/$mappingId': {
      id: '/app/mappings/$mappingId'
      path: '/mappings/$mappingId'
      fullPath: '/app/mappings/$mappingId'
      preLoaderRoute: typeof AppMappingsMappingIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/datasets/$id': {
      id: '/app/datasets/$id'
      path: '/$id'
      fullPath: '/app/datasets/$id'
      preLoaderRoute: typeof AppDatasetsIdRouteImport
      parentRoute: typeof AppDatasetsRoute
    }
    '/app/templates/$id/': {
      id: '/app/templates/$id/'
      path: '/'
      fullPath: '/app/templates/$id/'
      preLoaderRoute: typeof AppTemplatesIdIndexRouteImport
      parentRoute: typeof AppTemplatesIdRoute
    }
    '/app/templates/$id/mappings': {
      id: '/app/templates/$id/mappings'
      path: '/mappings'
      fullPath: '/app/templates/$id/mappings'
      preLoaderRoute: typeof AppTemplatesIdMappingsRouteImport
      parentRoute: typeof AppTemplatesIdRoute
    }
  }
}

interface AdminRouteChildren {
  AdminAuditRoute: typeof AdminAuditRoute
  AdminOrgsRoute: typeof AdminOrgsRoute
  AdminUsersRoute: typeof AdminUsersRoute
  AdminIndexRoute: typeof AdminIndexRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminAuditRoute: AdminAuditRoute,
  AdminOrgsRoute: AdminOrgsRoute,
  AdminUsersRoute: AdminUsersRoute,
  AdminIndexRoute: AdminIndexRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

interface AppDatasetsRouteChildren {
  AppDatasetsIdRoute: typeof AppDatasetsIdRoute
  AppDatasetsIndexRoute: typeof AppDatasetsIndexRoute
}

const AppDatasetsRouteChildren: AppDatasetsRouteChildren = {
  AppDatasetsIdRoute: AppDatasetsIdRoute,
  AppDatasetsIndexRoute: AppDatasetsIndexRoute,
}

const AppDatasetsRouteWithChildren = AppDatasetsRoute._addFileChildren(
  AppDatasetsRouteChildren,
)

interface AppTemplatesIdRouteChildren {
  AppTemplatesIdMappingsRoute: typeof AppTemplatesIdMappingsRoute
  AppTemplatesIdIndexRoute: typeof AppTemplatesIdIndexRoute
}

const AppTemplatesIdRouteChildren: AppTemplatesIdRouteChildren = {
  AppTemplatesIdMappingsRoute: AppTemplatesIdMappingsRoute,
  AppTemplatesIdIndexRoute: AppTemplatesIdIndexRoute,
}

const AppTemplatesIdRouteWithChildren = AppTemplatesIdRoute._addFileChildren(
  AppTemplatesIdRouteChildren,
)

interface AppTemplatesRouteChildren {
  AppTemplatesIdRoute: typeof AppTemplatesIdRouteWithChildren
  AppTemplatesIndexRoute: typeof AppTemplatesIndexRoute
}

const AppTemplatesRouteChildren: AppTemplatesRouteChildren = {
  AppTemplatesIdRoute: AppTemplatesIdRouteWithChildren,
  AppTemplatesIndexRoute: AppTemplatesIndexRoute,
}

const AppTemplatesRouteWithChildren = AppTemplatesRoute._addFileChildren(
  AppTemplatesRouteChildren,
)

interface AppRouteChildren {
  AppDatasetsRoute: typeof AppDatasetsRouteWithChildren
  AppExportsRoute: typeof AppExportsRoute
  AppTemplatesRoute: typeof AppTemplatesRouteWithChildren
  AppIndexRoute: typeof AppIndexRoute
  AppMappingsMappingIdRoute: typeof AppMappingsMappingIdRoute
  AppSettingsApiKeysRoute: typeof AppSettingsApiKeysRoute
  AppSettingsGoogleRoute: typeof AppSettingsGoogleRoute
  AppSettingsMembersRoute: typeof AppSettingsMembersRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppDatasetsRoute: AppDatasetsRouteWithChildren,
  AppExportsRoute: AppExportsRoute,
  AppTemplatesRoute: AppTemplatesRouteWithChildren,
  AppIndexRoute: AppIndexRoute,
  AppMappingsMappingIdRoute: AppMappingsMappingIdRoute,
  AppSettingsApiKeysRoute: AppSettingsApiKeysRoute,
  AppSettingsGoogleRoute: AppSettingsGoogleRoute,
  AppSettingsMembersRoute: AppSettingsMembersRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRouteWithChildren,
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
  RegisterRoute: RegisterRoute,
  AcceptInviteTokenRoute: AcceptInviteTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
